export const componentPageStyles = {
  root: {
    paddingX: { xs: 2, md: 5, lg: 0 },
    marginX: { xs: 0, lg: 6 },
    maxWidth: { xs: "100%", lg: "1200px", xl: "1384px" },
    backgroundColor: "white",
    minHeight: "100vh",
  },
  ssml: {
    paddingX: { xs: 2, md: 5, lg: 3.75 },
    marginX: { xs: 0, lg: 6 },
    maxWidth: { xs: "100%", lg: "1200px", xl: "1384px" },
    backgroundColor: "white",
    minHeight: "100vh",
  }
};
